module.exports = __webpack_public_path__ + "f044095ce2aa4f6222dd0c87bfca5244.MP3";